<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <ONumberInput v-model="model" :placeholder="placeholder" :disabled="normalizedDisabled" :min="min" :max="max"
        :step="step" :step-strictly="stepStrictly" :precision="precision" :controls="controls"
        :controls-position="controlsPosition" @change="(attrs.onChange)">
        <template v-if="slots['decrease-icon']" #decrease-icon>
          <slot name="decrease-icon"></slot>
        </template>
        <template v-if="slots['increase-icon']" #increase-icon>
          <slot name="increase-icon"></slot>
        </template>
        <template v-if="slots['prefix']" #prefix>
          <slot name="prefix"></slot>
        </template>
        <template v-if="slots['suffix']" #suffix>
          <slot name="suffix"></slot>
        </template>
      </ONumberInput>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormNumberInputProps } from './NumberInput'
import ONumberInput from '../../Input/NumberInput/NumberInput.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs, useSlots } from 'vue'

defineOptions({ name: 'OFormNumber', inheritAttrs: false })
const slots = useSlots()
const attrs = useAttrs()

const {
  name,
  label,
  labelWidth,
  required,
  placeholder,
  min,
  max,
  step,
  stepStrictly,
  precision,
  controls = true,
  controlsPosition,
} = defineProps<FormNumberInputProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
